import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';
import Dispatcher from '../Dispatcher';
import TourActionTypes from './TourActionTypes';

class TourStore extends ReduceStore {
    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        // eslint-disable-next-line new-cap
        return Immutable.OrderedMap({});
    }

    reduce(state, action) {
        let newState = null;
        switch (action.type) {
            case TourActionTypes.UPDATE_STATE:
                newState = state.merge({
                    ...action.appState,
                });
                break;
            default:
                break;
        }
        return newState || state;
    }
}

export default new TourStore();
